module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/123live.svg?0a0470f93025b5a8bde820afc3261284";